import { StyleSheet } from 'react-native';

import { colors } from '../../colors';

export const styles = StyleSheet.create({
  card: {
    backgroundColor: colors.cardSurface,
    borderColor: colors.cardBorder,
    borderRadius: 12,
    borderWidth: 1,
    gap: 8,
    padding: 16
  },
  error: {
    color: colors.textError,
    fontSize: 12
  },
  metricLabel: {
    color: colors.textLabel,
    fontSize: 12
  },
  metricRow: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  metricValue: {
    color: colors.textValue,
    fontWeight: '600'
  },
  status: {
    color: colors.textStatus,
    fontSize: 12
  },
  subtitle: {
    color: colors.textSubtitle,
    fontSize: 12
  },
  title: {
    color: colors.textTitle,
    fontSize: 18,
    fontWeight: '700'
  }
});
